import keyCodes from './utils/keyCodes';

const toastTemplate = `
<div class="error-actions">
	<a href="#" class="error-close"><span class="icon icon-x" /></a>
	<a href="#" class="error-btn"></a>
	<div class="error-sm reload-time"></div>
</div>
<div class="error-content">
	<h3 class="error-title"></h3>
	<span class="error-text"></span>
</div>
`;

const countdownIntervalTime = 1000;

export function showToast(title, message, actionTitle, secondsToReload, onAction) {
	Screen.elements.error.html('');

	const errorControl = $(toastTemplate);
	Screen.elements.error.append(errorControl);
	const reloadTime = Screen.elements.error.find('.reload-time');

	const errorText = Screen.elements.error.find('.error-text');
	const errorTitle = Screen.elements.error.find('.error-title');
	const reloadBtn = Screen.elements.error.find('.error-btn');
	const closeBtn = Screen.elements.error.find('.error-close');
	let countdownInterval = null;

	errorText.text(message);
	errorTitle.text(title);
	reloadBtn.text(actionTitle);

	if (secondsToReload) {
		reloadTime.text(`Reloading in ${secondsToReload}s`);
		--secondsToReload;
		// eslint-disable-next-line no-inner-declarations
		function updateTimer() {
			reloadTime.text(`Reloading in ${secondsToReload}s`);
			if (secondsToReload === 0) {
				reloadTime.text('Reloading...');
				clearInterval(countdownInterval);
				window.location.reload(true);
			} else {
				--secondsToReload;
			}
		}

		countdownInterval = setInterval(updateTimer, countdownIntervalTime);
	}

	reloadBtn.on('click', function(e) {
		e.preventDefault();
		onAction();
	});

	$(document).on('keydown.errorToast', function(inEvent) {
		const isEnter = inEvent.key === 'Enter' || (inEvent.which || inEvent.keyCode) === keyCodes.enter;
		if (isEnter) {
			onAction();
		}
	});

	closeBtn.on('click', function(e) {
		e.preventDefault();
		clearInterval(countdownInterval);
		Screen.hideError();
	});

	Screen.elements.error.show();
}
export function unbindToastEvents() {
	$(document).off('keydown.errorToast');
}
